<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <v-card>
      <v-card-text>
        <v-form
          ref="formNewConvocatoria"
          lazy-validation
          @submit.prevent="save()"
        >
          <v-card-title class="pa-2">
            {{ isEdit ? 'Modificar convocatoria' : 'Crear convocatoria' }}
            <v-spacer />
          </v-card-title>

            <v-text-field
              v-model="nombre"
              label="Nombre"
              class="px-2 py-1"
              flat
              hide-details
              outlined
              required
              :rules="[v => !!v || 'El nombre es obligatorio']"
            />
            <v-text-field
              v-model="cantidadDeModulosLicitados"
              label="Modulos licitados"
              class="px-2 py-1"
              flat
              hide-details
              outlined
              :rules="[v => !!v || 'La cantidad de modulos licitados es obligatoria']"
            />
            <v-divider />

            <v-select
              v-model="estadosConvocatoriaSelected"
              class="px-2 py-1"
              outlined
              flat
              :items="estadosConvocatoria"
              label="Estado de convocatoria"
              :rules="[v => !!v || 'El Estado de convocatoria es obligatorio']"
            />
          <!-- <div>
            <v-text-field
              v-model="cantidadDeModulos"
              class="px-2 py-1"
              flat
              label="Cantidad de modulos"
              hide-details
              outlined
              :rules="[v => !!v || 'La cantidad de modulos es obligatorio']"
              required
            />
            <v-divider />
          </div> -->

          <v-card-actions class="pa-2">
            <v-btn
              outlined
              @click="close"
            >
              Cancelar
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  // import firebase from 'firebase'

  // const db = firebase.firestore()

  export default {
    data () {
      return {
        dialog: false,
        loading: false,
        nombre: '',
        cantidadDeModulos: '',
        convocatoria: undefined,
        estadosConvocatoria: [],
        estadosConvocatoriaSelected: '',
        cantidadDeModulosLicitados: ''
      }
    },
    computed: {
      isEdit () {
        return this.convocatoria === undefined ? false : 'a'
      }
    },
    mounted () {
      this.estadosConvocatoria = this.$store.state.estadosConvocatorias
    },
    methods: {
      open (item) {
        this.dialog = true
        this.convocatoria = item
        if (this.isEdit) {
          this.nombre = item.nombre || ''
          this.cantidadDeModulos = item.cantidad_de_modulos_registrados || ''
          this.cantidadDeModulosLicitados = item.cantidad_de_modulos_licitados || ''
          this.estadosConvocatoriaSelected = item.estado || ''
        }
      },
      close () {
        this.dialog = false
        this.$refs.formNewConvocatoria.reset()
        this.loading = false
      },
      async save () {
        if (this.$refs.formNewConvocatoria.validate() && this.isEdit === false) {
          this.loading = true

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/convocatoria', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              nombre: this.nombre,
              cantidad_de_entidades_tecnicas: 0,
              cantidad_de_modulos_registrados: 0,
              cantidad_de_modulos_licitados: this.cantidadDeModulosLicitados || 0,
              estado: this.estadosConvocatoriaSelected
            })
          })
          const data = await response.json()
          if (data.success) {}

          this.close()
          this.$emit('onCreate')
        } else {
          if (this.$refs.formNewConvocatoria.validate() && this.isEdit) {
            this.loading = true

            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/convocatoria/' + this.convocatoria.id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              nombre: this.nombre,
              // cantidad_de_entidades_tecnicas: 0,
              // cantidad_de_modulos_registrados: 0,
              cantidad_de_modulos_licitados: this.cantidadDeModulosLicitados || 0,
              estado: this.estadosConvocatoriaSelected
            })
          })
          const data = await response.json()
          if (data.success) {}

          this.close()
          this.$emit('onCreate')
          }
        }
      },
    }
  }
</script>
